import React, { useEffect } from 'react'
import Button from '../Reusable/Button'
import AOS from 'aos'

const Home = () => {
    useEffect(() => {
        AOS.init({
            easing: 'ease-in-out',
            duration: 700,
        });
    }, [])
    return (
        <div  className='flex flex-col mt-6 z-[400]'>
            <div className='absolute lg:block hidden w-[400px] h-[400px] left-[-100px] top-[-200px] bg-blue-400 bg-opacity-30 rounded-full blur-2xl'></div>
            <div  className='flex lg:flex-row flex-col lg:mt-14 w-full justify-between gap-[5%] z-[500] lg:items-start items-center'>
                <div data-aos="fade-right" className='lg:w-1/2 w-full text-white flex flex-col lg:items-start items-center gap-4'>
                    <p className='lg:text-[40px] text-[30px] lg:text-start text-center font-bold text-white'>Your one-stop-shop for  <span className='text-[#2366CF]'>mining crypto</span></p>
                    <p className='lg:text-xl lg:text-start text-center'>At our state-of-the-art facilities, we offer a complete solution for all your crypto mining needs. Purchase top-of-the-line miners from trusted brands and let us handle the hosting, ensuring maximum efficiency and profitability for your mining operations</p>
                    <Button
                        link={"allProducts"}
                        title={"See Products"}
                    />
                    <div>
                        <p className='lg:text-[25px] font-semibold text-white'>Trusted by</p>
                        <div className='grid grid-cols-5'>
                            <img src="/Blockfarm/bitman.svg" alt="" />
                            <img src="/Blockfarm/iceriver.svg" alt="" />
                            <img src="/Blockfarm/jasminer.svg" alt="" />
                            <img src="/Blockfarm/canaan.svg" alt="" />
                            <img src="/Blockfarm/whatminner.svg" alt="" />
                        </div>
                    </div>
                </div>

                <div data-aos={"fade-in"} className='lg:w-1/2 w-full relative lg:justify-end flex' >
                    <div className='absolute w-[600px] h-[600px] left-1  top-0 bg-blue-400 bg-opacity-10 rounded-full blur-2xl'></div>
                    <img  className='z-[500] rounded-2xl' src="/Blockfarm/farm1.jpg" alt="" />
                </div>
            </div>

        </div>
    )
}

export default Home